const konfiguration = {
    anbieternummer: '0204000822',
    zulagerechner: {
        meldung: 'Sie nutzen nicht die volle Zulage, die Ihnen zusteht. Bitte wenden Sie sich an Ihren persönlichen Berater vor Ort, um Ihren optimalen Beitrag errechnen zu lassen. Gern können Sie sich auch mit unserem Kunden-Service-Center unter 0351/4235-0 in Verbindung setzen.',
        zusaetzlicherButton: false,
        buttonZiel: '',
        buttonText: ''
    },
  footer: {
    impressum: 'https://www.sv-sachsen.de/impressum',
    datenschutz: 'https://www.sv-sachsen.de/datenschutz',
    kontakt: 'https://www.sv-sachsen.de/kontakt'
  }
}
export default konfiguration;
